import { render, staticRenderFns } from "./Consultation.vue?vue&type=template&id=44198445&scoped=true"
import script from "./Consultation.vue?vue&type=script&lang=js"
export * from "./Consultation.vue?vue&type=script&lang=js"
import style0 from "./Consultation.vue?vue&type=style&index=0&id=44198445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44198445",
  null
  
)

export default component.exports